// extracted by mini-css-extract-plugin
export default {"landscapeDocumentsWrapper":"LandscapeProjectsAddProjectsDocumentsTemplate_landscapeDocumentsWrapper__Vtvq8"};